import Button from '../common/Button';
import buildResourcePath from '@lib/buildResourcePath'
import ProjectConfigurationViewer from './ProjectConfigurationViewer';
import ConfigurationReadOnlyApiService from '@lib/api-services/ConfigurationReadOnlyApiService';
import APIServicesRegistry from '@lib/api-services/APIServicesRegistry';
import configurationStore from '../../store/configuration';
import ProjectConfigurationPage from './ProjectConfigurationPage';
import ExpandableFloatingDropdown from '../common/ExpandableFloatingDropdown';

const ProjectConfigurationViewPage = class ProjectConfigurationViewPage extends ProjectConfigurationPage {
    configurationEditorComponentClass = ProjectConfigurationViewer

    static defaultProps = {
        configurationAPIService: ConfigurationReadOnlyApiService
    }

    constructor(props) {
        super(props)
        configurationStore.editableMode = false;
        scheduleAtDocumentReady(() => {
            this.setState({_forceUpdate: !this.state._forceUpdate});
        })
    }

    save() {
    }

    edit = () => {
        var configurationId = this.props.id.value
        var projectId = this.props.projectId

        window.location.href = buildResourcePath(`Project/EditConfiguration?projectId=${projectId}&configurationId=${configurationId}`)
    }

    getDesktopActionButtons() {
        var buttons = []
        if (this.props.canSetProductSerialNumber) {
            buttons.push(<Button key={1}
                                 onClick={() => this.onSetSerialNumberClick()}>{__('Set serial number')}</Button>)
        }
        if (this.props.canEdit) {
            buttons.push(<Button key={1} onClick={() => this.edit()}>{__('Edit')}</Button>)
        }

        return buttons;
    }

    getMobileActionButtons() {

        var buttons = []
        if (this.props.canEdit)
            buttons.push(<ExpandableFloatingDropdown.Item
                onClick={() => this.edit()}>{__('Edit')}</ExpandableFloatingDropdown.Item>)

        return buttons;
    }
}

window.components.ProjectConfigurationViewPage = ProjectConfigurationViewPage
